import _ from 'lodash';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router';
import App from './app';
import loadAppData from './common/routines/load-app-data';
import { getClasArDashboard, getCurrentUser } from './common/routines/user-operations';
import { routes } from './constants/routes';
import {
  CollectionsDashboard,
  ProjectionsDashboard,
  ReceivablesDashboard,
} from './features/dashboard/dashboard-sections';
import {
  AccountNumber,
  AccountTypeDefinition,
  GLTemplate,
  SegmentDefinition,
} from './features/glconfiguration';
import JournalGLException from './features/journals/GLExceptionScreens/GLExceptionScreen';
import TrustGLException from './features/journals/GLExceptionScreens/trustGLExceptionScreen';
import GLConfigScreen from './features/journals/journalGlconfig';
import TrustGLConfigScreen from './features/journals/journalGlconfig/trustJournalGlconfig';
import Journals from './features/journals/journalReports';
import Login from './features/login';
import Reports from './features/reports';
import { BulkStatement, IndividualStatement } from './features/statements';
import {
  TrustAccounts,
  TrustClosed,
  TrustDefaults,
  TrustDetailedReport,
  TrustEquityOnCancelled,
  TrustItemsReport,
  TrustModule,
  TrustMonthlyReport,
} from './features/trust';

const mstp = (state) => {
  return {
    isLoggedIn: state.session.isLoggedIn,
    appDataLoading: state.appearance.appDataLoading,
    permissions: state.support?.policies?.permissions,
    clasArDashboard: state.session?.clasArDashboard,
  };
};

const mdtp = (dispatch) => {
  return {
    setLoggedIn: (value, clasArDashboard) => {
      dispatch({
        type: 'SESSION:SET_IS_LOGGED_IN',
        payload: { value, clasArDashboard },
      });
    },
  };
};

export default connect(
  mstp,
  mdtp,
)((props) => {
  useEffect(() => {
    const loggedIn = !_.isEmpty(getCurrentUser());
    const isClasArDashboard = getClasArDashboard();
    props.setLoggedIn(loggedIn, isClasArDashboard);
  }, [props.setLoggedIn]);

  useEffect(() => {
    if (props.isLoggedIn) {
      loadAppData();
    }
  }, [props.isLoggedIn]);

  return (
    <App>
      <Switch>
        {props.isLoggedIn ? (
          <Route
            render={() => (
              <Switch>
                <Route path={routes.DASHBOARD_RECEIVABLES} component={ReceivablesDashboard} />
                <Route path={routes.DASHBOARD_COLLECTIONS} component={CollectionsDashboard} />
                <Route path={routes.DASHBOARD_PROJECTIONS} component={ProjectionsDashboard} />
                <Route path={routes.INDIVIDUAL} component={IndividualStatement} />
                <Route path={routes.BULK} component={BulkStatement} />
                <Route path={routes.JOURNALS} component={Journals} />
                <Route path={routes.TRUST} component={TrustModule} />
                <Route path={routes.TRUST_ACCOUNTS} component={TrustAccounts} />
                <Route path={routes.TRUST_CLOSED} component={TrustClosed} />
                <Route path={routes.TRUST_DEFAULTS} component={TrustDefaults} />
                <Route path={routes.TRUST_ITEMS_REPORT} component={TrustItemsReport} />
                <Route path={routes.TRUST_MONTHLY_REPORT} component={TrustMonthlyReport} />
                <Route path={routes.TRUST_DETAILED_REPORT} component={TrustDetailedReport} />
                <Route path={routes.GL_CONFIG_SCREEN} component={GLConfigScreen} />
                <Route path={routes.TRUST_GL_CONFIG_SCREEN} component={TrustGLConfigScreen} />
                <Route path={routes.GL_EXCEPTION_SCREEN} component={JournalGLException} />
                <Route path={routes.TRUST_GL_EXCEPTION_SCREEN} component={TrustGLException} />
                <Route path={routes.TRUST_EQUITY} component={TrustEquityOnCancelled} />
                <Route path={routes.REPORTS} component={Reports} />
                <Route path={routes.ACCOUNT_TYPE_DEFINITION} component={AccountTypeDefinition} />
                <Route path={routes.SEGMENT_DEFINITION} component={SegmentDefinition} />
                <Route path={routes.ACCOUNT_NUMBER} component={AccountNumber} />
                <Route path={routes.GL_TEMPLATE} component={GLTemplate} />
                {props.clasArDashboard ? (
                  <Route path="*" render={() => <Redirect to={routes.DASHBOARD_RECEIVABLES} />} />
                ) : (
                  <Route path="*" render={() => <Redirect to={routes.REPORTS} />} />
                )}
              </Switch>
            )}
          />
        ) : (
          <Route
            render={() => (
              <>
                <Route path={routes.LOGIN} component={Login} isLoggedIn={props.isLoggedIn} />
                <Route path="*" render={() => <Redirect to={routes.LOGIN} />} />
              </>
            )}
          />
        )}
      </Switch>
    </App>
  );
});
